var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-tab",class:{'tab-active': _vm.$parent.value === _vm.value},on:{"click":_vm.clickPane}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }